import { render, staticRenderFns } from "./UndoOrRedo.vue?vue&type=template&id=30ac74c0&scoped=true&"
var script = {}
import style0 from "./UndoOrRedo.vue?vue&type=style&index=0&id=30ac74c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac74c0",
  null
  
)

export default component.exports